import { useNavigate, useLocation } from "react-router-dom";
import { auth } from "../lib/supabase.js";

const nav = [
  { path: "/", label: "Dashboard", icon: "⊞" },
  { path: "/accounts", label: "Accounts", icon: "👥" },
];

export default function Layout({ children, mrr }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div style={{ display: "flex", minHeight: "100vh", fontFamily: "'DM Sans', -apple-system, sans-serif", background: "#08080c", color: "#e0e0e0" }}>
      {/* Sidebar */}
      <nav style={{ width: 220, minHeight: "100vh", background: "#0a0a10", borderRight: "1px solid #141428", padding: "24px 0", display: "flex", flexDirection: "column", flexShrink: 0 }}>
        {/* Logo */}
        <div style={{ padding: "0 20px", marginBottom: 32 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 32, height: 32, borderRadius: 8, background: "linear-gradient(135deg, #6366f1, #4f46e5)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, color: "#fff", fontWeight: 700 }}>⚡</div>
            <div>
              <div style={{ fontSize: 15, fontWeight: 700 }}>Clarifico</div>
              <div style={{ fontSize: 10, color: "#555", textTransform: "uppercase", letterSpacing: "0.1em", fontWeight: 600 }}>AI Platform</div>
            </div>
          </div>
        </div>

        {nav.map((item) => (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            style={{
              display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "10px 20px",
              background: location.pathname === item.path ? "#12122a" : "transparent",
              borderRight: location.pathname === item.path ? "2px solid #6366f1" : "2px solid transparent",
              border: "none", borderLeft: "none", borderTop: "none", borderBottom: "none",
              color: location.pathname === item.path ? "#e0e0e0" : "#666",
              fontSize: 13, fontWeight: 600, cursor: "pointer", textAlign: "left", fontFamily: "inherit",
            }}
          >
            <span style={{ fontSize: 16 }}>{item.icon}</span>
            {item.label}
          </button>
        ))}

        <div style={{ flex: 1 }} />

        {/* MRR display */}
        {mrr !== undefined && (
          <div style={{ padding: "0 20px", marginBottom: 16 }}>
            <div style={{ padding: 14, background: "#0f0f1a", borderRadius: 10, border: "1px solid #1a1a2e" }}>
              <div style={{ fontSize: 10, color: "#555", textTransform: "uppercase", letterSpacing: "0.06em", fontWeight: 700, marginBottom: 4 }}>Platform MRR</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: "#34d399" }}>${mrr.toLocaleString()}</div>
            </div>
          </div>
        )}

        <button
          onClick={() => auth.signOut()}
          style={{ margin: "0 20px", padding: "8px 0", background: "none", border: "1px solid #1a1a2e", borderRadius: 8, color: "#555", fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}
        >
          Sign Out
        </button>
      </nav>

      {/* Main content */}
      <main style={{ flex: 1, padding: 32, overflowY: "auto", maxHeight: "100vh" }}>
        {children}
      </main>
    </div>
  );
}
